<template>
  <v-layout class="chat__toolbar">
    <v-layout grow>
      <v-toolbar class="pa-0 secondary-background" align-center min-height="64px">
        <v-layout column>
          <v-layout align-center>
            <v-skeleton-loader
              v-if="$route.params.conversation_id && !currentConversation.session.id"
              type="sentences"
              width="300"
            ></v-skeleton-loader>

            <v-layout
              style="min-width: 350px"
              class="d-flex flex-row align-center"
              v-if="currentConversation.session.customer.crm_ref"
              column>
              <div>
                <v-layout align-center>
                  <span class="font-weight-medium text-uppercase">
                    <b>{{ currentConversation.session.customer.name }}</b>
                  </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span
                        class="status-conversation"
                        :class="currentConversation.session.status"
                        v-on="on"
                        >{{
                          currentConversation.session.status | conversationStatus | firstLetter
                        }}</span
                      >
                    </template>
                    <span>
                      {{ currentConversation.session.status | conversationStatus }}
                    </span>
                  </v-tooltip>

                  <v-tooltip
                    v-if="currentConversation.session.is_paused"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">pause</v-icon>
                    </template>
                    <span>Conversa interrompida</span>
                  </v-tooltip>
                </v-layout>
                <span class="font-weight-light document">{{
                  currentConversation.session.customer.document | document
                }}</span>
              </div>
              <v-btn
                class="ml-2"
                color="primary"
                @click.stop="openExternalRef"
                v-shortkey="['ctrl', '\\']"
                @shortkey="openExternalRef()"
                text
                small>
                CRM
              </v-btn>
              <v-btn
                class="ml-2"
                color="#e1a53a"
                @click.stop="openExternalHermesRef"
                v-shortkey="['ctrl', 'space']"
                @shortkey="openExternalHermesRef()"
                text
                small>
                Hermes
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    class="ml-2"
                    color="primary"
                    v-bind="attrs"
                    @click.stop="openGetDeals()"
                    :loading="loadingQuiteJaDeals"
                    text
                    small>
                    Acordos
                  </v-btn>
                </template>
                <div v-if="listDeals">
                  <v-list
                    class="pa-0"
                  >
                    <template
                      v-for="(item, index) in this.deals"
                    >
                    <v-list-item
                      :key="item.id || index"
                    >
                      <v-list-item-content>
                      <v-list-item-title
                        >{{ getCreditorName(item) + " - " + item.id }}
                        <v-chip
                          v-if="isExpired(item.expires_in)"
                          color="black"
                          class="white--text ml-2 status-deal"
                          small>
                          Expirado
                        </v-chip>
                        <v-chip class="ml-2 status-deal white--text" :class="item.status" small>
                          {{ item.status | dealStatus }}
                        </v-chip>

                        <v-chip
                          v-if="item.status === 'WAITING' && item.waiting_cause"
                          class="ml-2 status-deal white--text"
                          color="red darken-1"
                          small
                        >
                          {{ item.waiting_cause | dealWaitingCause }}
                        </v-chip>

                        <v-chip
                          v-if="item.payments[0]?.boleto?.url"
                          class="ml-2"
                          @click.stop="sendBoleto(item.payments[0].boleto)">
                          Enviar boleto
                        </v-chip>
                      </v-list-item-title>

                        <v-list-item-subtitle
                          v-if="getAgreementDescription(item)"
                        >
                          {{ getAgreementDescription(item) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <div class="ml-2 d-flex align-center">
                        <v-btn
                        color="primary"
                          x-small
                          text
                          prepend-icon="mdi-open-in-new"
                          class="mr-2"
                          @click="openClosedDeals(item.id)"
                          >Backoffice</v-btn
                        >
                        <v-btn
                        color="#e1a53a"
                          x-small
                          text
                          prepend-icon="mdi-open-in-new"
                          @click="openHermesClosedDeals(item.id)"
                          >Hermes</v-btn
                        >
                      </div>
                    </v-list-item>

                      <v-divider
                        v-if="index < deals.length - 1"
                        :key="`deal-divider-${item.id || index}`"
                      ></v-divider>
                    </template>
                  </v-list>
                </div>
              </v-menu>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" class="ml-2" color="primary" v-bind="attrs" text small>
                    {{ currentConversation.session.source }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, idx) in sourceTypes" :key="idx">
                    <v-list-item-title @click="changeSessionSource(item)" style="cursor: pointer"
                      >{{ item | sessionSourceType }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip
                v-if="currentConversation?.session?.sender && sessionsFromOtherServices.length > 0"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="$emit('show-sessions-from-other-services')"
                  >
                    <v-badge
                      :content="sessionsFromOtherServices.length"
                      overlap
                    >
                      <v-icon>forum</v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <span>Conversas em outros canais</span>
              </v-tooltip>
            </v-layout>
            <v-layout v-else-if="currentConversation.session.customer.empresas">
              <v-menu bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-on="on" v-bind="attrs">Me Lembre</v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(link, empresa) in currentConversation.session.customer.empresas"
                    :key="link"
                    :link="true"
                    :href="link"
                    target="_blank">
                    <v-list-item-title>
                      {{ empresa }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-layout>
            <v-layout style="min-width: 350px" v-else align-center>
              <v-btn
                class="add-info-btn text-span"
                text
                @click.stop="openEditConversation()"
                v-if="currentConversation.session.id"
                >Informar dados</v-btn
              >
              <v-tooltip bottom v-if="currentConversation.session.id">
                <template v-slot:activator="{ on }">
                  <span
                    class="status-conversation"
                    :class="currentConversation.session.status"
                    v-on="on"
                    >{{
                      currentConversation.session.status | conversationStatus | firstLetter
                    }}</span
                  >
                </template>
                <span>
                  {{ currentConversation.session.status | conversationStatus }}
                </span>
              </v-tooltip>

              <v-tooltip
                v-if="currentConversation.session.is_paused"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">pause</v-icon>
                </template>
                <span>Conversa interrompida</span>
              </v-tooltip>
            </v-layout>
            <v-flex shrink>
              <v-layout column px-4>
                <v-layout justify-end align-end>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-avatar
                    :size="30"
                    color="grey lighten-4"
                    v-on="on"
                    v-show="
                      currentConversation.session.user_id &&
                      currentConversation.session.user_id != loggedUser.id
                    ">
                    <img
                      v-if="currentConversation.session.user"
                      :src="currentConversation.session.user.profile_photo_url || '/img/default.png'"
                      alt="avatar" />
                  </v-avatar>
                    </template>
                    <span v-if="currentConversation.session.user">
                      {{ currentConversation.session.user.name }}
                    </span>
                  </v-tooltip>
                </v-layout>
              </v-layout>
            </v-flex>
            <v-layout shrink d-flex align-end justify-end>
              <v-btn
                v-if="currentConversation.session.id"
                :loading="loadingRefreshMessages"
                color="primary"
                outlined
                justify-center
                small
                class="mr-2"
                style="display: flex; justify-content: space-between;"
                @click.stop="refreshMessages">
                <v-icon rigth>refresh</v-icon>
                Atualizar mensagens
              </v-btn>
              <v-btn
                v-if="currentConversation.session.id"
                :loading="loadingMessages"
                color="primary"
                justify-center
                small
                class="mr-12"
                @click.stop="LoadFullHistory">
                Carregar histórico
              </v-btn>
              <!-- this.currentConversation.last_event.type != 'INITIATIVE'" -->
              <v-btn
                class="mx-1"
                v-show="isAssingToMeAndOpened && currentConversation.session.status == 'PENDING'"
                color="blue"
                dark
                @click.stop="openWaitingForDialog"
                v-shortkey="['ctrl', 'a']"
                @shortkey="openWaitingForDialog()"
                small>
                Aguardando
              </v-btn>

              <v-btn
                class="mx-1"
                v-show="
                  checkAttendent() &&
                  !['CLOSED', 'CLOSING', 'WAITING_CUSTOMER'].includes(
                    currentConversation.session.status
                  )
                "
                color="primary"
                :loading="preparingWaitingStatus"
                @click.stop="prepareWaitingStatusChange('CLOSING')"
                v-shortkey="['ctrl', 'r']"
                @shortkey="prepareWaitingStatusChange('CLOSING')"
                small>
                Finalizar
              </v-btn>

              <v-btn
                class="mx-1"
                v-show="isAssingToMeAndNotOpened"
                color="primary"
                @click.stop="changeStatus([currentConversation, 'PENDING'])"
                small>
                <v-icon>play_arrow</v-icon>
                Reabrir
              </v-btn>

              <v-btn
                class="mx-1"
                v-show="isNotAssingToMe"
                color="blue"
                @click.stop="doAssing"
                small
                v-if="currentConversation.session.id">
                <v-icon rigth>move_to_inbox</v-icon>
                Atribuir
              </v-btn>
              <v-dialog v-model="dialog" width="300" @keydown.esc="close">
                <template v-slot:activator="{ on }">
                  <div v-on.stop="on" @click.stop v-on="on">
                    <slot name="activator"></slot>
                  </div>
                </template>
                <v-card v-if="dialog" class="secondary-background">
                  <v-card-text class="d-flex flex-column pt-5">
                    <div
                      v-shortkey="['ctrl', '3']"
                      @shortkey="forceWaitingCustomerStatusChange()"
                    ></div>

                    <v-btn
                      class="mx-1"
                      color="blue"
                      dark
                      :loading="preparingWaitingStatus"
                      @click.stop="prepareWaitingStatusChange('WAITING_CUSTOMER')"
                      v-shortkey="['ctrl', '1']"
                      @shortkey="prepareWaitingStatusChange('WAITING_CUSTOMER')"
                      text>
                      <!-- <v-icon>replay_30</v-icon> -->
                      Aguardando cliente
                    </v-btn>

                    <v-btn
                      class="mx-1"
                      color="orange"
                      dark
                      :loading="preparingWaitingStatus"
                      @click.stop="prepareWaitingStatusChange('WAITING_TREATMENT')"
                      v-shortkey="['ctrl', '2']"
                      @shortkey="prepareWaitingStatusChange('WAITING_TREATMENT')"
                      text>
                      Aguardando tratamento
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="waitingStatusDialog"
                max-width="500"
                persistent
                @keydown.esc="keepConversationOpen()">
                <v-card class="secondary-background">
                  <v-card-title class="text-h6">
                    Confirmar alteração de status
                  </v-card-title>
                  <v-card-text>
                    <p class="mb-4">
                      A conversa foi atualizada com as mensagens mais recentes.
                      Revise o conteúdo e escolha se deseja seguir para
                      <strong>{{ waitingStatusTargetLabel }}</strong> ou manter a conversa aberta.
                    </p>
                    <v-alert
                      dense
                      outlined
                      type="info"
                      class="mb-0">
                      Tempo restante: {{ waitingStatusCountdownLabel }}
                    </v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="keepConversationOpen">
                      Manter conversa aberta
                    </v-btn>
                    <v-btn
                      v-if="waitingStatusDialog"
                      color="primary"
                      @click="confirmWaitingStatusChange"
                      v-shortkey="['enter']"
                      @shortkey="confirmWaitingStatusChange()">
                      Continuar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list
                :class="`${
                  this.$vuetify.theme.dark ? 'tertiary-background' : 'secondary-background'
                }`">
                <v-list-item
                  v-if="!isNotAssingToMe && currentConversation.session.status == 'PENDING'"
                  @click="openEditConversation()">
                  <v-list-item-title>Editar conversa</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isAdmin" @click="openSendToVacation()">
                  <v-list-item-title>Férias</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!isNotAssingToMe && currentConversation.session.expired"
                  @click="isSessionExpired()">
                  <v-list-item-title>Checar expirado</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openNewSession()">
                  <v-list-item-title>Iniciar Conversa</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="toggleSessionPause()"
                >
                  <v-list-item-title>
                    {{ currentConversation.session?.is_paused ? "Retomar conversa" : "Interromper conversa" }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="toChangeShowStatusHistory()">
                  <v-list-item-title>
                    {{ showStatusHistory ? "Ocultar alterações de status" : "Exibir alterações de status" }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-layout>
        </v-layout>
      </v-toolbar>
    </v-layout>
    <EditConversation ref="editConversation" />
    <SendToVacation ref="sendToVacation" />
    <NewSession ref="newSession" />
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import environment from "@/assets/js/environment";
import EditConversation from "./EditConversation";
import SendToVacation from "./SendToVacation";
import NewSession from "./NewSession";
import moment from "moment";

export default {
  components: {
    EditConversation,
    SendToVacation,
    NewSession,
  },
  data() {
    return {
      dialog: false,
      waitingStatusDialog: false,
      waitingStatusTarget: null,
      historyActive: false,
      loadingMessages: false,
      loadingRefreshMessages: false,
      loadingQuiteJaDeals: false,
      preparingWaitingStatus: false,
      waitingStatusCountdown: 60,
      waitingStatusCountdownInterval: null,
      combobx: false,
      sourceTypes: ["AT", "RA", "ST"],
      offset: 0,
      listDeals: false,
    };
  },
  computed: {
    ...mapGetters("rasaConversation", {
      currentConversation: "currentConversation",
      historyLoaded: "historyLoaded",
      sessionsFromOtherServices: "sessionsFromOtherServices",
      deals: "deals",
      showStatusHistory: "showStatusHistory",
    }),
    ...mapGetters({
      loggedUser: "getLoggedUser",
    }),
    isAdmin() {
      return this.loggedUser.roles.includes("admin");
    },
    isAssingToMeAndOpened() {
      return (
        this.currentConversation.session.user_id &&
        this.currentConversation.session.user_id == this.loggedUser.id &&
        this.currentConversation.session.status == "PENDING"
      );
    },
    isAssingToMeAndNotOpened() {
      return (
        this.currentConversation.session.user_id &&
        this.currentConversation.session.user_id == this.loggedUser.id &&
        ["WAITING_TREATMENT", "CLOSING", "WAITING_CUSTOMER"].includes(
          this.currentConversation.session.status
        )
      );
    },
    isNotAssingToMe() {
      return (
        !this.currentConversation.session.user_id ||
        this.currentConversation.session.user_id != this.loggedUser.id
      );
    },
    waitingStatusCountdownLabel() {
      const minutes = String(Math.floor(this.waitingStatusCountdown / 60)).padStart(2, "0");
      const seconds = String(this.waitingStatusCountdown % 60).padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
    waitingStatusTargetLabel() {
      if (this.waitingStatusTarget === 'WAITING_TREATMENT') {
        return 'Aguardando tratamento';
      }

      if (this.waitingStatusTarget === 'CLOSING') {
        return 'Finalizar conversa';
      }

      return 'Aguardando cliente';
    },
  },
  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
    }),
    ...mapMutations("rasaSessions", {
      setStatusToShow: "setStatusToShow",
    }),
    ...mapActions("rasaSessions", {
      changeSessionStatus: "changeSessionStatus",
      assignToMe: "assignToMe",
      checkExpiration: "checkExpiration",
      changeSessionPause: "changeSessionPause",
      changeSessionSource: "changeSessionSource",
      backToNormal: "backToNormal",
      resetAndReloadChatList: "resetAndReloadChatList",
    }),
    ...mapActions("rasaConversation", {
      loadConversationHistory: "loadConversationHistory",
      refreshCurrentConversation: "refreshCurrentConversation",
      clearConversationHistory: "clearConversationHistory",
      clearCurrentConversationMessages: "clearCurrentConversationMessages",
      getDeals: "getDeals",
      changeShowStatusHistory: "changeShowStatusHistory",
    }),
    ...mapActions("rasaEvents", {
      sendMessage: "send",
    }),
    async isSessionExpired() {
      await this.checkExpiration();
    },

    /**
     * Retorna a descrição do acordo na QuiteJá.
     */
    getAgreementDescription(deal) {
      if (!deal) {
        return null;
      }

      let description = [];

      let formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });

      if (deal.down_payment) {
        let downPayment = formatter.format(deal.down_payment);
        description.push(downPayment);
      }

      // Quantidade de parcelamentos do fluxo irregular
      let installmentsCount = 5;

      for (let i = 1; i <= installmentsCount; i++) {
        if (deal[`installments_count_${i}`] && deal[`installment_${i}`]) {
          let installmentValue = formatter.format(deal[`installment_${i}`]);
          description.push(`+ ${deal[`installments_count_${i}`]} x ${installmentValue}`);
        }
      }

      description = description.join(' ');
      description = description.trim();

      // Remove o + do início se não tiver entrada
      if (description.startsWith('+')) {
        description = description.slice(1).trim();
      }

      return description;
    },

    getCreditorName(deal) {
      if (!deal || !deal.creditor) {
        return '';
      }

      let creditorName = deal.creditor.name;

      if (deal.creditor_profile && deal.creditor_profile.long_name != deal.creditor.name) {
        creditorName = `${deal.creditor.name} (${deal.creditor_profile.long_name})`;
      }

      return creditorName;
    },

    isExpired(date) {
      const vencimento = moment(date);
      let hoje = moment().startOf("day");
      const diasDeAtraso = vencimento.diff(hoje, "days");
      // console.log(diasDeAtraso);
      if (diasDeAtraso < 0) {
        return true;
      } else {
        return false;
      }
    },

    async toggleSessionPause() {
      try {
        await this.changeSessionPause();
        this.showSnackbar('Conversa alterada');
      } catch (error) {
        console.error('Erro ao alterar a conversa:', error);
        this.showSnackbar('Não foi possível alterar a conversa');
      }
    },

    async changeStatus(payload) {
      await this.changeSessionStatus(payload);
      this.clearWaitingStatusCountdown();
      this.waitingStatusDialog = false;
      this.waitingStatusTarget = null;
      this.dialog = false;
    },

    openExternalRef() {
      let url = environment.externalRefUrl + this.currentConversation.session.crm_ref;
      window.open(url, "_blank");
    },

    openExternalHermesRef() {
      let url = environment.externalRefHermesUrl + this.currentConversation.session.crm_ref;
      window.open(url, "_blank");
    },

    openClosedDeals(deal) {
      let url = `${environment.backofficeUrl}/deal/${deal}`;
      window.open(url, "_blanck");
    },

    openHermesClosedDeals(deal) {
      let url = `${environment.hermesUrl}/deal/${deal}`;
      window.open(url, "_blanck");
    },

    checkAttendent() {
      if (this.loggedUser?.id == this.currentConversation?.session.user_id) return true;
      return false;
    },
    openSendToVacation() {
      this.$refs.sendToVacation.open();
    },
    openNewSession() {
      this.$refs.newSession.open();
    },
    openEditConversation() {
      const payload = {
        user_id: this.currentConversation.session.user_id,
        name: this.currentConversation.session.customer.name,
        document: this.currentConversation.session.customer.document,
        crm_ref: this.currentConversation.session.customer.crm_ref,
        id: this.currentConversation.session.id,
      };
      this.$refs.editConversation.open(payload);
    },
    openWaitingForDialog() {
      this.dialog = true;
    },
    clearWaitingStatusCountdown() {
      if (!this.waitingStatusCountdownInterval) {
        return;
      }

      clearInterval(this.waitingStatusCountdownInterval);
      this.waitingStatusCountdownInterval = null;
    },
    startWaitingStatusCountdown() {
      this.clearWaitingStatusCountdown();
      this.waitingStatusCountdown = 60;

      this.waitingStatusCountdownInterval = setInterval(() => {
        if (this.waitingStatusCountdown <= 1) {
          this.keepConversationOpen(false);
          return;
        }

        this.waitingStatusCountdown -= 1;
      }, 1000);
    },
    scrollConversationToTop() {
      const el = document.getElementById('scroll_messages');

      if (!el) {
        return;
      }

      el.scrollTo({ top: 0, behavior: 'auto' });
    },
    async prepareWaitingStatusChange(targetStatus) {
      this.preparingWaitingStatus = true;

      try {
        this.dialog = false;
        this.waitingStatusTarget = targetStatus;
        await this.refreshCurrentConversation();
        await this.loadConversationHistory({ offset: this.offset, isHistoryLoaded: true });
        this.historyActive = true;
        this.offset += 100;
        this.scrollConversationToTop();
        this.waitingStatusDialog = true;
        this.startWaitingStatusCountdown();
      } catch (error) {
        console.error('Não foi possível preparar a alteração de status.', error);
        this.showSnackbar('Não foi possível atualizar a conversa antes da alteração de status');
      } finally {
        this.preparingWaitingStatus = false;
      }
    },
    async forceWaitingCustomerStatusChange() {
      this.preparingWaitingStatus = true;

      try {
        await this.changeStatus([this.currentConversation, 'WAITING_CUSTOMER']);
        await this.clearCurrentConversationMessages();
        await this.clearConversationHistory();
        this.offset = 0;
        this.historyActive = false;
        this.showSnackbar('Status alterado para aguardando cliente sem confirmação');
      } catch (error) {
        console.error('Não foi possível alterar o status para aguardando cliente sem confirmação.', error);
        this.showSnackbar('Não foi possível alterar para aguardando cliente sem confirmação');
      } finally {
        await this.resetAndReloadChatList();
        this.preparingWaitingStatus = false;
      }
    },
    async confirmWaitingStatusChange() {
      if (!this.waitingStatusTarget || this.preparingWaitingStatus) {
        return;
      }

      const statusLabel = this.waitingStatusTargetLabel;
      const targetStatus = this.waitingStatusTarget;
      this.preparingWaitingStatus = true;

      try {
        await this.changeStatus([this.currentConversation, targetStatus]);
        this.showSnackbar(`Status alterado para ${statusLabel.toLowerCase()} e conversa limpa`);
      } catch (error) {
        console.error('Não foi possível confirmar a alteração de status.', error);
        this.showSnackbar(`Não foi possível alterar para ${statusLabel.toLowerCase()}`);
      } finally {
        const cleanupPromises = [
          this.clearCurrentConversationMessages(),
          this.clearConversationHistory(),
        ];

        this.offset = 0;
        this.historyActive = false;
        this.loadingMessages = false;
        this.loadingRefreshMessages = false;
        this.clearWaitingStatusCountdown();
        this.waitingStatusDialog = false;
        this.waitingStatusTarget = null;

        const cleanupResults = await Promise.allSettled(cleanupPromises);

        if (cleanupResults.some((result) => result.status === 'rejected')) {
          console.error('Não foi possível limpar totalmente a conversa após a confirmação.', cleanupResults);
        }

        this.setStatusToShow('PENDING');
        await this.resetAndReloadChatList();
        await this.backToNormal();

        this.preparingWaitingStatus = false;
      }
    },
    keepConversationOpen(showFeedback = true) {
      this.clearWaitingStatusCountdown();
      this.waitingStatusDialog = false;
      this.waitingStatusTarget = null;

      if (showFeedback) {
        this.showSnackbar('Conversa mantida aberta com as mensagens atualizadas');
      }
    },
    async refreshMessages() {
      this.loadingRefreshMessages = true;

      try {
        await this.refreshCurrentConversation();
        this.showSnackbar('Mensagens atualizadas');
      } catch (error) {
        console.error('Não foi possível atualizar as mensagens.', error);
        this.showSnackbar('Não foi possível atualizar as mensagens');
      } finally {
        this.loadingRefreshMessages = false;
      }
    },
    async LoadFullHistory() {
      this.historyActive = true;
      this.loadingMessages = true;

      try {
      await this.loadConversationHistory({ offset: this.offset, isHistoryLoaded: true });
      } catch (error) {
        console.error('Não foi possível carregar as mensagens.', error);
        this.showSnackbar('Não foi possível carregar as mensagens');
      } finally {
        this.loadingMessages = false;
      }

      this.offset += 100;
    },

    async doAssing() {
       try {
        await this.assignToMe(this.currentConversation.session.id);
        window.location.reload();
      } catch (error) {
        if (error.response && error.response.status === 428) {
          this.showSnackbar("Você está de férias, aproveite!");
        } else {
          console.error("Erro ao atribuir conversa:", error);
          this.showSnackbar("Erro ao atribuir a conversa.");
        }
      }
    },
    async openGetDeals() {
      this.combobx = true;
      this.listDeals = true;
      this.loadingQuiteJaDeals = true;

      try {
        await this.getDeals();
      } catch (error) {
        console.error('Não foi possível listar os acordos.', error);
        this.showSnackbar('Não foi possível listar os acordos');
      } finally {
        this.loadingQuiteJaDeals = false;
      }
    },
    async toChangeShowStatusHistory() {
      await this.changeShowStatusHistory(!this.showStatusHistory);
    },
    async sendBoleto(boleto) {
      let payload = {
        messages: [
          {
            sender: this.currentConversation?.session.sender,
            content_type: boleto.content_type,
            content: {
              file_name: boleto.original_name,
              url: boleto.url,
            },
            user_id: this.currentConversation?.session.user_id,
            session_id: this.currentConversation?.session.id,
          },
        ],
      };
      await this.sendMessage(payload);
      payload = {};
      this.listDeals = false;
    },
  },
  beforeDestroy() {
    this.clearWaitingStatusCountdown();
  },
};
</script>

<style lang="scss" scoped>
.chat__toolbar {
  height: 64px;
  background: whitesmoke;
  z-index: 998;
}

.status-conversation {
  font-size: 11px;
  font-weight: 500;
  border-radius: 3px;
  margin-left: 5px;
  height: 17px;
  line-height: 17px;
  width: 17px;
  text-align: center;

  color: white;
  background-color: gray;

  &.PENDING {
    color: white;
    background-color: #2196f3;
  }

  &.AUTO {
    color: white;
    background-color: rgb(255, 0, 0);
  }

  &.WAITING_TREATMENT {
    color: white;
    background-color: #06f038;
  }

  &.WAITING_CUSTOMER {
    color: white;
    background-color: #34c6ff;
  }
  &.CLOSING {
    color: white;
    background-color: #ff8800;
  }
  &.CLOSE {
    color: white;
    background-color: #000000;
  }
}

.status-deal {
  font-size: 11px;
  font-weight: 500;

  &.CREATED {
    background-color: #2196f3;
  }

  &.STARTED {
    background-color: #4caf50;
  }

  &.WAITING {
    background-color: #6075b0;
  }

  &.AGREED {
    background-color: #b71ee9;
  }

  &.RESOLVED {
    background-color: #ff4081;
  }

  &.RENEGOTIATED {
    background-color: #673ab7;
  }

  &.ABORTED,
  &.expired {
    background-color: #212121;
  }

  &.not-notifiable {
    background-color: #ff9800;
  }

  &.waiting-cause {
    background-color: #dd2c00;
  }

  &.FOMENTATION {
    background-color: #630bff;
  }

  &.RENEGOTIATION {
    background-color: #cdb34a;
  }
}
</style>
